import Vue from "vue";
import configs from "../configs";
import { stringify } from "query-string";

const ip = configs.apiBase;

const retrieve = (cnpj) => {
  return Vue.prototype.$http.get(`${ip}/new/arquivos/certificados/find?cpfCnpj=${cnpj}`);
};

const insert = (certificado, cnpj) => {
  const formData = new FormData();
  formData.append(`file`, certificado.arquivos[0]);
  formData.append("cpfCnpj", cnpj);
  formData.append("password", certificado.senha);
  return Vue.prototype.$http.post(`${ip}/new/arquivos/certificados/upload`, formData);
};

const remove = (cnpj) => {
  return Vue.prototype.$http.delete(`${ip}/new/arquivos/certificados/remove?cpfCnpj=${cnpj}`);
};

const download = (cnpj) => {
  return Vue.prototype.$http.get(`${ip}/new/arquivos/certificados/download?cpfCnpj=${cnpj}`, {
    responseType: "blob",
  });
};

const sortToString = (sort) => {
  const keys = Object.keys(sort);
  const value = `${sort[keys[0]]}`.replace(/\d/im, "");
  return `${value}${keys[0]}`;
};

const getVencendo = (search) => {
  const auxSearch = { ...search };
  auxSearch.sort = sortToString(auxSearch.sort);
  return Vue.prototype.$http.get(
    `${ip}/new/arquivos/certificados/expiring?${stringify(auxSearch)}`,
  );
};

export default {
  retrieve,
  insert,
  remove,
  download,
  getVencendo,
};
